// extracted by mini-css-extract-plugin
export default {"container":"BaseOptionsItem_container__bIFAp","editor":"BaseOptionsItem_editor__FeQTx","label":"BaseOptionsItem_label__PpOty"};